import options from './thing-registered.component';

export default {
    selector: 'dtAsThingRegistered',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-registered/index.js